import * as amplitude from '@amplitude/analytics-browser'

type CommaSeparatedList<T extends string> = T | `${T}, ${T}` | `${T}, ${T}, ${T}` | `${T}, ${T}, ${T}, ${T}`

function toolsClicks(
  properties: {
    'type of partner': string
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('Tools Clicks', properties, options)
}

function codeCopied(
  properties: {
    'code copied': string
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('Code Copied', properties, options)
}

function challengesPageViseted(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('Challenges Page Viseted', properties, options)
}

function passChosen(
  properties: {
    'pass type': 'silver pass' | 'golden pass'
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('Pass Chosen', properties, options)
}

function challengeProductChosen(
  properties:
    | {
        'product type': 'cfd'
        'cfd evaluation type': 'phase 1' | 'phase 2'
        'cfd starting balance': '5 000' | '10 000' | '20 000' | '50 000' | '200 000'
        'cfd trading platform': 'metatrade 4' | 'metatrade 5' | 'ctrader'
        'cfd full price': number
      }
    | {
        'product type': 'futures'
        'futures type': 'Prime'
        'futures prime balance': '50 000' | '100 000' | '150 000'
        'futures full price': number
      }
    | {
        'product type': 'futures'
        'futures type': 'Classic'
        'futures сlassic balance': '20 000' | '150 000' | '200 000' | '250 000'
        'futures full price': number
      }
    | {
        'product type': 'stocks'
        'stocks starting balance': number
        'stocks full price': number
      },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('Challenge Product Chosen', properties, options)
}

function stocksAddonsChosen(
  properties: {
    'stocks market data addon': string // 'level 1' | 'level 2' | 'level 1, level 2'
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('Stocks Addons Chosen', properties, options)
}

function futuresPlatformAddonsChosen(
  properties: {
    'futures trading platform': 'ninjatrader' | 'tradovate' | 'atas' | 'quantower' | 'deepchart' | 'rtrader'
    'futures market data addon': CommaSeparatedList<
      'level 1 us' | 'level 2 chicago' | 'level 2 us' | 'european market data'
    >
    'futures added dates'?: '60' | '90'
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('Futures Platform, Addons Chosen', properties, options)
}

function qcTitleChosen(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Title Chosen', properties, options)
}

function qcNameFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Name Filled', properties, options)
}

function qcLastNameFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Last Name Filled', properties, options)
}

function qcEmailedFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Emailed Filled', properties, options)
}

function qcCountryChosen(properties: { 'qc country name': string }, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Country Chosen', properties, options)
}

function qcPhoneFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Phone Filled', properties, options)
}

function qcTermsAccepted(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Terms Accepted', properties, options)
}

function qcIDConfirmationAccepted(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc ID Confirmation Accepted', properties, options)
}

function qcNewsletterWanted(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Newsletter Wanted', properties, options)
}

function qcRecaptchaPassed(
  properties: {
    'qc recaptcha passed': 'cliked passed' | 'cliked failed'
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('qc Recaptcha Passed', properties, options)
}

function qcCityFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc City Filled', properties, options)
}

function qcPOZipCodeFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc PO/Zip Code Filled', properties, options)
}

function qcAddressFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('qc Address Filled', properties, options)
}

function cityFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('City Filled', properties, options)
}

function pOZipCodeFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('PO/Zip Code Filled', properties, options)
}

function addressFilled(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('Address Filled', properties, options)
}

function aiReviewRequested(
  properties: {
    'technology provider account id': string
    'account name': string
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('AI Review Requested', properties, options)
}

function aiReviewFeedbackSubmitted(
  properties: {
    'review id': number
    rating: 'like' | 'dislike'
    'has comment': boolean
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('AI Review Feedback Submitted', properties, options)
}

function aiReviewRefreshed(
  properties: {
    'technology provider account id': string
  },
  options?: amplitude.Types.EventOptions,
) {
  return amplitude.track('AI Review Refreshed', properties, options)
}

function rfTermsOpened(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('RF Terms Opened', properties, options)
}

function rfMessageCopied(properties?: {}, options?: amplitude.Types.EventOptions) {
  return amplitude.track('RF Message Copied', properties, options)
}

export const track = {
  // cookiesAccepted,
  toolsClicks,
  codeCopied,
  challengesPageViseted,
  challengeProductChosen,
  futuresPlatformAddonsChosen,
  qcTitleChosen,
  qcNameFilled,
  qcLastNameFilled,
  qcEmailedFilled,
  qcCountryChosen,
  qcPhoneFilled,
  qcCityFilled,
  qcPOZipCodeFilled,
  qcAddressFilled,
  qcRecaptchaPassed,
  qcTermsAccepted,
  qcIDConfirmationAccepted,
  qcNewsletterWanted,
  cityFilled,
  pOZipCodeFilled,
  addressFilled,
  passChosen,
  stocksAddonsChosen,
  aiReviewRequested,
  aiReviewFeedbackSubmitted,
  aiReviewRefreshed,
  rfTermsOpened,
  rfMessageCopied,
}
